import React from 'react'
import { LayoutTwo } from '../../Layout/CommonStyle'
import Main from './Main'
import Menu from './Menu'

function MyPage() {
  const [menuIndex, setMenuIndex] = React.useState(0)

  return (
    <LayoutTwo>
      <Menu menuIndex={menuIndex} setMenuIndex={setMenuIndex} />
      <Main menuIndex={menuIndex} />
    </LayoutTwo>
  )
}

export default MyPage
